

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import {KhoaPhong} from "@/models/khoaPhong";
import {DonViCreate} from "@/models/donViCreate";
import CDCRepository from "@/services/CDCRepository";
import {FilterMatchMode} from "primevue/api";

export default {

  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const donVi = ref({} as DonViCreate);
    const donViUpdate = ref({} as DonViCreate);
    const listDonVi = ref([] as DonViCreate[]);
    const update = ref(false);

    // const valid = computed(()=> register.value.password && register.value.username  && register.value.fullname
    //     && register.value.phoneNumber&& register.value.permission&& (register.value.idKhoaPhong > 0));

    if(!(store.state.permission == 'admin')){
      router.push({
        name: 'home'
      });
    }
    const getListDonVi = () => {
      CDCRepository.getListDonVi()
          .then((response) => {
            listDonVi.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    getListDonVi();

    const doRegister = () => {
        CDCRepository.createDonVi(donVi.value)
                .then((response) => {
                  getListDonVi();
                  toast.add({
                    severity: 'success',
                    summary: 'Thêm đơn vị',
                    detail: 'Thêm đơn vị thành công vào hệ thống',
                    life: 2000
                  });
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail:err.response.data,
                    life: 2000
                  });
                });
    }

    const getDonViById = (id) => {
      CDCRepository.getDonViById(id)
          .then((response) => {
            donViUpdate.value = response.data
            update.value = true;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const updateDonVi = () => {
      CDCRepository.updateDonVi(donViUpdate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Cập nhật đơn vị',
              detail: 'Cập nhật đơn vị thành công vào hệ thống',
              life: 2000
            });
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    return {
      doRegister,
      donVi,
      listDonVi,
      clearFilter,
      initFilters,
      filters,
      getDonViById,
      donViUpdate,
      update,
      updateDonVi,
    }
  }
}

